export default __webpack_public_path__ + "static/media/vip-logo-diamond-current.85aae507.webp";